<template>
  <!-- 商户号批量导入结果。失败的行不写库，这里把行号和原因原样列出来，方便对着表格改。
       REQ-2026-751517 返工：从 payMerchant.vue 里提出来，账套列表页的全量导入和二级页的按渠道导入共用一份，
       不要再各页复制一个。 -->
  <el-dialog title="批量导入结果" :visible.sync="visible" width="640px">
    <template v-if="result">
      <el-descriptions :column="4" border size="small">
        <el-descriptions-item label="总行数">{{ result.total }}</el-descriptions-item>
        <el-descriptions-item label="新增">{{ result.insertCount }}</el-descriptions-item>
        <el-descriptions-item label="更新">{{ result.updateCount }}</el-descriptions-item>
        <el-descriptions-item label="失败">
          <span :style="{ color: result.failCount > 0 ? '#f56c6c' : '#67c23a' }">{{ result.failCount }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <div v-if="result.failReasons && result.failReasons.length" style="margin-top:16px">
        <div style="font-weight:bold;margin-bottom:8px">失败原因</div>
        <div style="max-height:300px;overflow-y:auto;background:#fef0f0;padding:12px;border-radius:4px">
          <div v-for="(reason, index) in result.failReasons" :key="index"
            style="line-height:22px;color:#f56c6c">{{ reason }}</div>
        </div>
      </div>
    </template>
    <div slot="footer">
      <el-button type="primary" @click="visible = false">知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PayMerchantImportResultDialog',
  data() {
    return {
      visible: false,
      result: null
    }
  },
  methods: {
    /** 父页拿到导入接口返回的 data 后调这个 */
    show(result) {
      this.result = result
      this.visible = true
    }
  }
}
</script>
